import httpClient from '@apiClient'
import { calendarDataLayer } from '@plugin/google/gtm/modules/property'
import { buildUrl } from '@plugin/http/lib/utils'
import { getTime, joinStr, timeDiff } from '@utils'
import { Base64 } from 'js-base64'

/**
 * 生成ics文件
 * @param {object} event
 * @param {string} fileName
 */
async function downloadIcs(event, fileName) {
  const { url } = await httpClient.post('ics', {
    start: event.start,
    end: event.end,
    title: Base64.encode(event.title),
    description: Base64.encode(event.description),
    location: Base64.encode(event.location),
    allDay: event.all_day_event,
    url: Base64.encode(window.location.href),
    fileName
  })

  const elink = document.createElement('a')
  elink.setAttribute('href', url)
  elink.style.display = 'none'
  elink.setAttribute('data-noprogress', true)
  document.body.appendChild(elink)
  elink.click()
  setTimeout(() => {
    document.body.removeChild(elink)
  }, 1000)
}

// 下载apple ics文件
export function downloadAppleIcs(event) {
  calendarDataLayer.addApple()
  return downloadIcs(event, 'apple')
}

// 下载outlook ics文件
export function downloadOutlookIcs(event) {
  calendarDataLayer.addOutlook()
  return downloadIcs(event, 'outlook')
}

// 添加outlook.com calendar
export function downloadOutlookOnline(event) {
  calendarDataLayer.addOutlookOnline()
  const params = {
    rru: 'addevent',
    startdt: event.start ? getTime(event.start.getTime() / 1000, 'YYYYMMDDTHHmmssZ') : null,
    enddt: event.end ? getTime(event.end.getTime() / 1000, 'YYYYMMDDTHHmmssZ') : null,
    subject: event.title,
    location: event.location,
    allday: event.all_day_event ? 1 : 0,
    path: '/calendar/action/compose'
  }
  window.open(buildUrl('https://outlook.live.com', undefined, params))
}

// 添加google calendar
export function downloadGoogle(event) {
  calendarDataLayer.addGoogle()
  const params = {
    action: 'TEMPLATE',
    text: encodeURIComponent(event.title),
    location: event.location,
    dates: joinStr([
      event.start ? getTime(event.start.getTime() / 1000, 'YYYYMMDDTHHmmssZ') : undefined,
      event.end ? getTime(event.end.getTime() / 1000, 'YYYYMMDDTHHmmssZ') : undefined
    ], '/'),
    trp: 'false'
  }
  window.open(buildUrl('https://www.google.com/calendar/render', undefined, params))
}

// 添加yahoo calendar
export function downloadYahoo(event) {
  calendarDataLayer.addYahoo()
  const params = {
    v: 60,
    TITLE: event.title,
    ST: event.start ? getTime(event.start.getTime() / 1000, 'YYYYMMDDTHHmmssZ') : null,
    DUR: event.end ? timeDiff(event.end.getTime() / 1000, event.start.getTime() / 1000, 'HHmm') : null,
    URL: window.location.href,
    in_loc: event.location,
    TYPE: 10
  }
  window.open(buildUrl('http://calendar.yahoo.com', undefined, params))
}
